import React, {useCallback, useContext, useEffect, useState} from "react";

import type {IAfterGuiAttachedParams, IDoesFilterPassParams,} from "ag-grid-community";
import type {CustomFilterProps} from "ag-grid-react";
import {useGridFilter} from "ag-grid-react";
import {Button} from "react-bootstrap";
import {ActionTypes} from "services/abuseWordsService";
import {AbuseActionTypeTag} from "pages/AbuseWords/components/AbuseActionTypeTag";
import {AuthContext} from "contexts";

export const AbuseActionTypesFilter = ({model, onModelChange}: CustomFilterProps) => {
    const {env} = useContext(AuthContext);

    const [closeFilter, setCloseFilter] = useState<(() => void) | undefined>();
    const [selectedValues, setSelectedValues] = useState<ActionTypes[] | null>(model);

    const doesFilterPass = useCallback((params: IDoesFilterPassParams) => {
        return !!selectedValues && selectedValues.some(item => params.data.actionType === item);
    }, [selectedValues]);

    const afterGuiAttached = useCallback(
        ({hidePopup}: IAfterGuiAttachedParams) => {
            setCloseFilter(() => hidePopup);
        },
        [],
    );

    // register filter handlers with the grid
    useGridFilter({
        doesFilterPass,
        afterGuiAttached,
    });

    useEffect(() => {
        setSelectedValues(model ?? []);
    }, [model]);

    const onClick = () => {
        if (closeFilter) {
            closeFilter();
        }
    };

    const sortedValues = Object.values(ActionTypes)
        .filter(v => typeof v === 'number')
        .sort((a, b) => ActionTypes[+a].toString().localeCompare(ActionTypes[+b].toString()));
    return (
        <div className="p-3 d-flex flex-column bg-white">
            <label className={'fw-bold'}>Действия</label>
            <div className="col-sm-10 mt-2">
                {sortedValues.map(value =>
                    <div key={value} className="form-check">
                        <input className="form-check-input"
                               type="checkbox"
                               value=""
                               id={value.toString()}
                               checked={selectedValues?.includes(value as ActionTypes)}
                               onChange={() => {
                                   const newValue = selectedValues?.includes(value as ActionTypes) ? selectedValues.filter(pg => pg !== value) : [...(selectedValues ?? []), value as ActionTypes];
                                   const agNewValue = newValue.length ? newValue : null;
                                   setSelectedValues(agNewValue);
                                   onModelChange(agNewValue);
                               }}/>
                        <AbuseActionTypeTag app={env?.app} action={+value}/>
                    </div>)}
            </div>
            <Button size={'sm'} variant={'secondary'} onClick={onClick} className={'mt-2'}>Готово</Button>
        </div>
    );
};